import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ImageWrapper from '../../../../../../new-components/ImageWrapper';
import { useEffect, useState } from 'react';

interface CoverSectionProps {
  marketingVideoPath?: string;
  videoUrl?: string;
  marketingImageSquarePath?: string;
  marketingImageWidePath?: string;
}
interface ContainerProps {
  webview?: boolean;
}

const CoverSection = ({
  marketingVideoPath,
  videoUrl,
  marketingImageSquarePath,
  marketingImageWidePath
}: CoverSectionProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const webview = useSelector((state: any) => state.app.webview);

  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    setPlayVideo(true);

    const handleUnmount = () => {
      setPlayVideo(false);
    };
    return handleUnmount;
  }, []);

  const getCover = () => {
    if (marketingVideoPath && playVideo) {
      return (
        <video
          style={{ width: '100%', height: '100%' }}
          autoPlay
          controls
          playsInline
        >
          <source src={marketingVideoPath} type="video/mp4" />
        </video>
      );
    }

    if (videoUrl && playVideo) {
      return (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${
            videoUrl.split('v=')[1]
          }?playsinline=1`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      );
    }
    return (
      <ImageWrapper
        src={isMobile ? marketingImageSquarePath! : marketingImageWidePath!}
        alt="cover-image"
        fill
        objectFit="cover"
        priority={true}
        withSkeleton
        imageSize={isMobile ? 'medium' : 'high'}
      />
    );
  };

  return <Container webview={webview !== 'partners'}>{getCover()}</Container>;
};

const Container = styled.div<ContainerProps>`
  position: relative;
  border-radius: ${props => props.theme.borderRadius};
  border-bottom-left-radius: ${props => props.webview && '0px'};
  border-bottom-right-radius: ${props => props.webview && '0px'};
  height: 500px;
  overflow: hidden;

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    height: 221px;
  }
`;

export default CoverSection;
